<template>
  <div class="ElevenTipDialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content-img" @click="goActivity">
        <img class="img" src="http://ftpfile.yunlsp.com/storage/vehicle/truckmp/group/eleven-activity-banner-new.png" alt srcset />
      </div>
    </van-popup>
    <div class="close-icon" v-if="showDialog" style="z-index: 3000" @click="closeDialog">
      <img src="../../../assets/images/hisTrack/close-monthticket-icon.png" alt srcset />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { setItem } from '../../../utils'
import { wxNavigateTo } from '../../../utils/WeChatUtil'
import { mapGetters } from 'vuex'
export default {
  props: {},
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    ...mapGetters({
      platform: 'platform'
    }),
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    showPopup() {
      this.showDialog = true
      setItem('showElevenAdvTime', moment().add(3, 'hours').format('YYYY-MM-DD HH:mm:ss'))
    },

    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },

    goActivity() {
      this.showDialog = false
      if (this.platform === 'TENCENT_WECHAT_MP_VEHICLE') {
        wxNavigateTo('../activity/Eleven/home/index')
      }
    },
  }
};
</script>

<style scoped lang="scss">
.ElevenTipDialog > :first-child {
  background-color: rgba(0, 0, 0, 0.4);
}
.ElevenTipDialog > :nth-child(2) {
  background-color: transparent;
  .content-img {
    width: 50vh;
    height: 36vh;
    height: 50%;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.close-icon {
  position: fixed;
  bottom: 10%;
  left: 50%;
  margin-left: -40px;
  z-index: 3000;
  text-align: center;
  img {
    width: 80px;
  }
}
</style>
